
import React, { useState, useEffect, useRef } from "react";
import cn from "classnames";
import styles from "../../components/Report/report.module.scss";
import Button from "@material-ui/core/Button";
import List from "../../components/Report/List";
import Master from "screen/Master";    
import Graph from "../../components/Report/Graph"
import { fade, withStyles } from '@material-ui/core/styles';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import {
  makeStyles,
  createMuiTheme,
  MuiThemeProvider
} from "@material-ui/core/styles";
import Switch from '@material-ui/core/Switch';



// const Styles = styled.div`
//   padding: 1rem;
//   table {
//     width:100%;
//     text-align-last: left;
//     th,
//     td { 
//       width:25%;
//       :last-child {
//         border-right: 1px solid #f5f5f5;
//       }
//     }
//   }
// }`;

let multiselectArray = [];
function ReportsView(props) {
  // 
    const[show,setShow]=useState(false);
    const [toggle,setToggle] = useState(false)
    const [userRole, setUserRole] = useState("");
    const [navigation, setNavigation] = useState(false);
    const [open, setOpen] = React.useState(false);
    const [tabSelect, setTabSelect] = useState(false);
    const [showList, setShowList] = useState(false);
    const [showGraph, setShowGraph] = useState(true);

    const refOpen = useRef(open);
    const [state, setState] = React.useState({
      checkedB: true,
    });
    
    const handleChange = (event) => {
      setState({ ...state, [event.target.name]: event.target.checked });
    };
  
    const handleChanges=()=>{
      console.log('show',show)

      setShow(!show);
  }
  const listChanges=()=>{
    setShowList(true);
    setShowGraph(false);
  }

  const graphChanges=()=>{
    setShowGraph(true);
    setShowList(false);
  }
    const toggler = () => {
      toggle ? setToggle(false):setToggle(true)
    }
    
    function useOutsideAlerter(ref, ref1) {
      useEffect(() => {
        function handleClickOutside(event) {
          if (ref.current && !ref.current.contains(event.target)) {
            setOpen(false);
            refOpen.current = false;
          } else {
            if (
              refOpen.current &&
              ref1.current &&
              !ref1.current.contains(event.target)
            ) {
              refOpen.current = false;
              setOpen(false);
            } else {
              setOpen(true);
              refOpen.current = true;
            }
          }
        }
  
        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          // Unbind the event listener on clean up
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [ref, ref1]);
    }
  
    const wrapperRef = useRef(null);
    const wrapperRefInside = useRef(null);
  
    useOutsideAlerter(wrapperRef, wrapperRefInside);
  
    const handleClick = () => {
      if (open) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };
  
    const IOSSwitch = withStyles((theme) => ({
      root: {
        width: 50,
        height: 26,
        padding: 0,
        margin: theme.spacing(1),
      },
      switchBase: {
        padding: 1,
        '&$checked': {
          transform: 'translateX(16px)',
          color: theme.palette.common.white,
          '& + $track': {
            backgroundColor: '#89cff0',
            opacity: 1,
            border: 'none',
          },
        },
        '&$focusVisible $thumb': {
          color: '#52d869',
          border: '6px solid #fff',
        },
      },
      thumb: {
        width: 24,
        height: 24,
        backgroundColor:"blu"
      },
      track: {
        borderRadius: 26 / 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        backgroundColor: theme.palette.grey[50],
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
      },
      checked: {},
      focusVisible: {},
    }))(({ classes, ...props }) => {
      return (
        <>
        {toggle ? <report/>:<list/>}
        <span>List</span>
        <Switch  onClick={()=>setShow(handleChanges)}
          focusVisibleClassName={classes.focusVisible}
          disableRipple
          classes={{
            root: classes.root,
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          {...props}
        />
        <span>Graph</span>
         </>
      );
    });
    const useStyles = makeStyles({
      button: {
        textTransform: "none",
      }
    });
  
    const classes = useStyles();
    return (
      <>
      
        <h2 className={cn(styles.medium_title, styles.medium_title_layout)}>
          {userRole.toLowerCase() === "admin"
            ? "Admin Dashboard"
            : "Reports"}
        </h2>
        <div className="btn-toggle">
          <ButtonGroup style={{padding:"50px 0px 30px 0px",hover:"#aaafff"}} onClick={()=>setShow(handleChanges)}   disableElevation variant="contained" color="primary">
        <Button className={classes.button} onClick={()=>{listChanges()}} style={ showList ?  {backgroundColor:"#23297A"} :  {backgroundColor:"#D6D7E3"}}>List View</Button>
        <Button className={classes.button} onClick={()=>graphChanges()}  style={ showGraph ?  {backgroundColor:"#23297A "} :  {backgroundColor:"#D6D7E3"}}>Graph View</Button>
      </ButtonGroup>
      </div>
      <div>
        {console.log('show1',showGraph)}
              {showList ? <List headerFilter={props.headerFilter} /> : showGraph ? <Graph headerFilter={props.headerFilter}  /> : ''}
          </div>    
      </>
    );
  }

export default function Reports(props) {
  const [headerFilter, setHeaderFilter] = useState(true);
  return (
    <>
      <Master opts={props} screen={ReportsView} showStatus={false} 
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter} 
       />
    </>
  );
}
Reports.inStorybook = true;
